import * as React from "react";
import { Link } from "react-router-dom";
import app from "../../core/application";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IMenu from "../../types/IMenu";
import IMenuItem from "../../types/IMenuItem";
import IUserSession from "../../types/IUserSession";
import Logo from "./cgi_logo.svg";
import NavCustomer from "./NavCustomer";
import NavDropdown from "./NavDropdown";

interface INavProps extends ITranslationProps {
    userSession: IUserSession | null;
    onLogout: () => void;
}

interface INavState {
    menuStates: boolean[];
    collapsed: boolean;
}

class Nav extends React.Component<INavProps, INavState> {

    public static getDerivedStateFromProps(nextProps: INavProps, prevState: INavState) {
        // Set up the array to track menu states based on how many menus we got from the server
        let menuCount = 0;
        if (nextProps.userSession) {
            menuCount = nextProps.userSession.menus.length + 1
        }

        if (menuCount !== prevState.menuStates.length) {
            prevState.menuStates = [];
            for (let i = 0; i < menuCount; i++) {
                prevState.menuStates.push(false);
            }
            return prevState;
        }
        return null;
    }

    constructor(props: INavProps) {
        super(props);

        this.state = { 
            menuStates: [],
            collapsed: true
        };

        this.logoutClick = this.logoutClick.bind(this);
        this.menuToggled = this.menuToggled.bind(this);
        this.toggleNavbar = this.toggleNavbar.bind(this);
    }

    public render() {
        let menuNumber = 0;
        let userInfoNode: React.ReactNode | null = null;
        const menuNodes: React.ReactNode[] = [];

        if (this.props.userSession) {

            userInfoNode = (
                <ul className="navbar-nav">
                    <NavDropdown name={this.props.userSession.firstName} id={menuNumber} isOpen={this.state.menuStates[menuNumber]} toggleMenu={this.menuToggled}>
                        <Link className="dropdown-item" to="/changePassword">{this.props.t("Nav.ChangePassword")}</Link>
                        <a className="dropdown-item" href="#" onClick={this.logoutClick}>{this.props.t("Nav.Logout")}</a>
                    </NavDropdown>
                </ul>
            );

            this.props.userSession.menus.forEach((menu: IMenu) => {
                const menuItems: React.ReactNode[] = [];

                menuNumber++;
                menu.menuItems.forEach((menuItem: IMenuItem) => {
                    menuItems.push(
                        <Link key={menuItem.name} to={menuItem.url} className="dropdown-item">{menuItem.name}</Link>
                    );
                });

                menuNodes.push(
                    <NavDropdown key={menuNumber} name={menu.name} id={menuNumber} isOpen={this.state.menuStates[menuNumber]} toggleMenu={this.menuToggled}>
                        {menuItems}
                    </NavDropdown>
                );
            });
        }

        const collapsed = this.state.collapsed;
        const navbarCollapseClass = collapsed ? "collapse navbar-collapse" : "collapse navbar-collapse show";
        const collapseButtonClass = collapsed ? "navbar-toggler navbar-toggler-right collapsed" : "navbar-toggler navbar-toggler-right";

        return (
            <div>
                <nav className="navbar navbar-expand-md navbar-dark bg-dark">
                    <Link to="" className="navbar-brand">
                        <div>
                            <img src={Logo} width="100" height="60" />
                        </div>
                        <div className="navbar-brand-title">NOTIFY SERVICE</div>
                    </Link>
                    <button 
                        onClick={this.toggleNavbar}
                        className={collapseButtonClass} 
                        type="button" 
                        data-toggle="collapse"
                        data-target="#navbarCollapse" 
                        aria-controls="navbarCollapse"
                        aria-expanded="false" 
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className={navbarCollapseClass} id="navbarCollapse">
                        <ul className="navbar-nav mr-auto" />
                        <div className="navbar-nav">
                            {menuNodes}
                            {userInfoNode}
                        </div>
                    </div>
                </nav>
                <NavCustomer userSession={this.props.userSession} />
            </div>
        );
    }

    private logoutClick() {
        app().logOutUser();
        this.props.onLogout();
    }

    private menuToggled(id: number, visible: boolean) {
        const newMenuState = this.state.menuStates;

        // Toggle the specified menu on or off
        newMenuState[id] = visible;

        if (visible) {
            // hide all the other menus
            newMenuState.forEach((value, index) => {
                if (index !== id) {
                    newMenuState[index] = false;
                }
            });
        }

        this.setState({menuStates: newMenuState});
    }

    private toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }
}

export default translateComponent(Nav);



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.tsx